import React from 'react';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/29ec9c1d-aa03-4e76-8da3-0164430670ac.jpg',
  quote: 'Siempre pensaba que el problema era el precio. Después entendí que era la forma en que presentaba mis productos. Cambié los nombres, agregué los rituales y mis clientas empezaron a decir que mi marca se veía mucho más profesional.',
  name: 'Valentina R.',
  place: 'Bogotá, Colombia'
}, {
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/a57c0752-9315-497f-bfc4-8217442163dc.jpg',
  quote: 'Las descripciones del Tomo 5 cambiaron por completo mi Instagram. Ahora la gente me escribe preguntando por los aromas porque dicen que pueden imaginarlos solo con leer la publicación.',
  name: 'Mariana L.',
  place: 'Ciudad de México'
}, {
  img: 'https://cdn.magicpatterns.com/patterns/generated-images/44be5f21-468d-438d-8b2d-ebb0408344ae.jpg',
  quote: 'Solo con aplicar las estrategias de la Biblioteca logré que mis colecciones se vieran mucho más profesionales. Hoy vendo experiencias, no solo productos.',
  name: 'Carolina S.',
  place: 'Santiago de Chile'
}];
export function Testimonials() {
  return <section className="w-full bg-[#f7f3ec] px-5 py-14" data-id="element-205" data-mp="7a4ukqvc5bjq">
      <div className="mx-auto max-w-md" data-id="element-206" data-mp="c7n0e8e23ani">
        <h2 className="text-center font-serif-display text-3xl font-bold leading-tight text-[#3b3350]" data-id="element-207" data-mp="zwfxi86ezojp">
          Lo que está cambiando en las marcas que aplican este sistema
        </h2>

        <div className="mt-8 space-y-5" data-id="element-208" data-mp="14xde4gbs0aj3">
          {testimonials.map(t => <figure key={t.name} className="rounded-2xl bg-white p-5 shadow-sm ring-1 ring-[#e4dbcc]" data-id="element-209" data-mp="q6curg9hqw86">
              <div className="flex items-center gap-3" data-id="element-210" data-mp="1ivk0p0b9yo3g">
                <img src={t.img} alt={`Foto de ${t.name}`} className="h-14 w-14 rounded-full object-cover ring-2 ring-[#d8c19a]/50" data-id="element-211" data-mp="1itz9nko65nac" />
                <div data-id="element-212" data-mp="1xfwlqyyz991j">
                  <figcaption className="font-semibold text-[#3b3350]" data-id="element-213" data-mp="1siwdqiikhw7s">{t.name}</figcaption>
                  <p className="text-xs text-[#8a8296]" data-id="element-214" data-mp="1sh33yucnqvvk">{t.place}</p>
                  <div className="mt-0.5 flex gap-0.5" data-id="element-215" data-mp="1ofrh2wl64or2">
                    {Array.from({
                  length: 5
                }).map((_, i) => <StarIcon key={i} className="w-3.5 h-3.5 fill-[#d8c19a] text-[#d8c19a]" data-id="element-216" data-mp="1jkkfpvfdfw5b" data-mpi={i} />)}
                  </div>
                </div>
              </div>
              <blockquote className="mt-3 text-sm italic leading-relaxed text-[#5a5266]" data-id="element-217" data-mp="19r3o8y2pit4t">
                “{t.quote}”
              </blockquote>
            </figure>)}
        </div>
      </div>
    </section>;
}